import React from 'react';
import { getProxyUrl } from '../../utils/image';
import SquadPlayer from './SquadPlayer';

const SQUAD_MAPPING = {
  goalkeepers: 'MÅLVAKTER',
  defenders: 'FÖRSVARARE',
  midfields: 'MITTFÄLTARE',
  forwards: 'ANFALLARE',
};

function Squad({ team, show, squad, loading, error }) {
  const squadImage = team?.squadImage;

  const renderSquadSection = (players, key) => {
    return (
      <div key={key}>
        <h2 className="heading-h6 heading-lg-h3 my-3 my-lg-4">
          {SQUAD_MAPPING[key]}
        </h2>
        <div className="overflow-x-auto d-flex flex-nowrap flex-lg-wrap row">
          {players.map((player) => (
            <SquadPlayer player={player} team={team} key={player.clId} />
          ))}
        </div>
      </div>
    );
  };

  if (loading || error || !show) return null;

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-12 tabs-column col-lg-8 offset-lg-2 my-3 my-lg-4">
          <img
            className="border-radius-10"
            width="100%"
            src={getProxyUrl(squadImage, 750, 1000)}
            alt=""
          />
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-12 tabs-column">
          {Object.keys(squad)?.map((key) =>
            renderSquadSection(squad[key], key)
          )}
        </div>
      </div>
    </>
  );
}

export default Squad;
